<template>
  <img :src="src" v-if="loaded" alt="" />
</template>

<script>
export default {
  props: [ 'src' ],
  data(){ return {
    loaded: false,
  }},
  computed: {   

  },
  
  created(){

    var _this = this
    var img = new Image()
    img.onload = function(){
      _this.loaded = true
    }
    img.src = this.src

  },

}
</script>



// WEBPACK FOOTER //
// ImgLoaded.vue?033cd4aa